import { render, staticRenderFns } from "./PrivasiView.vue?vue&type=template&id=b3c1c814&"
import script from "./PrivasiView.vue?vue&type=script&lang=js&"
export * from "./PrivasiView.vue?vue&type=script&lang=js&"
import style0 from "./PrivasiView.vue?vue&type=style&index=0&id=b3c1c814&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports